(() => {
  if (window.shakuntalaShoppingReady) return;
  window.shakuntalaShoppingReady = true;
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const copy = event.target.closest('[data-sk-offer-copy]');
    if (!copy) return;
    const offer = copy.closest('[data-sk-product-offer]');
    const code = offer.querySelector('[data-sk-product-offer-code]');
    const message = offer.querySelector('[data-sk-product-offer-status]');
    try {
      await navigator.clipboard.writeText(code.textContent.trim());
      copy.textContent = copy.dataset.copied;
      message.textContent = copy.dataset.copied;
    } catch (_) {
      const range = document.createRange();
      range.selectNodeContents(code);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      message.textContent = copy.dataset.copyFallback;
    }
  });
  const drawer = document.getElementById('sk-wishlist-dialog');
  if (!drawer) return;
  const strings = JSON.parse(drawer.querySelector('[data-sk-wishlist-strings]').textContent);
  const storageKey = 'shakuntala-wishlist-v1';
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_) {}
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  saved = Array.isArray(saved) ? [...new Set(saved.filter(validHandle))].slice(0, 100) : [];
  const list = drawer.querySelector('[data-sk-wishlist-items]');
  const status = document.querySelector('[data-sk-wishlist-status]');
  let renderVersion = 0;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: drawer.dataset.currency || 'INR', maximumFractionDigits: 2 }).format(value / 100);
  const update = () => {
    document.querySelectorAll('[data-sk-wishlist-toggle]').forEach(button => {
      const active = saved.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.saveLabel);
      const label = button.querySelector('[data-sk-wishlist-label]');
      if (label) label.textContent = active ? strings.saved : strings.save;
    });
    document.querySelectorAll('[data-sk-wishlist-count]').forEach(count => { count.textContent = saved.length; count.hidden = saved.length === 0; });
  };
  const persist = () => { try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {} update(); };
  const textNode = (tag, text, className) => { const node = document.createElement(tag); node.textContent = text; if (className) node.className = className; return node; };
  const render = async () => {
    const version = ++renderVersion;
    list.replaceChildren(textNode('p', saved.length ? strings.loading : strings.empty));
    if (!saved.length) return;
    const handles = [...saved];
    const results = await Promise.allSettled(handles.map(async handle => {
      const response = await fetch(`${drawer.dataset.root}products/${encodeURIComponent(handle)}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unavailable product');
      return response.json();
    }));
    if (version !== renderVersion) return;
    list.replaceChildren();
    results.forEach((result, index) => {
      const handle = handles[index];
      const row = document.createElement('div'); row.className = 'sk-wishlist-item';
      const detail = document.createElement('div');
      const productLink = document.createElement('a'); productLink.href = `${drawer.dataset.root}products/${handle}`;
      if (result.status === 'fulfilled') {
        const product = result.value;
        const imageLink = productLink.cloneNode();
        if (product.featured_image) { const img = document.createElement('img'); img.src = product.featured_image; img.alt = product.title; img.width = 90; img.height = 124; img.loading = 'lazy'; imageLink.append(img); }
        row.append(imageLink);
        productLink.append(textNode('h3', product.title)); detail.append(productLink);
        const variant = product.variants?.find(v => v.available) || product.variants?.[0];
        const price = variant?.price ?? product.price;
        const compare = variant?.compare_at_price;
        const priceLine = textNode('p', money(price));
        if (compare > price) priceLine.append(textNode('s', money(compare)));
        detail.append(priceLine, textNode('p', product.available ? strings.available : strings.soldOut, 'sk-wishlist-availability'));
      } else {
        row.append(document.createElement('div'));
        productLink.append(textNode('h3', handle.replaceAll('-', ' '))); detail.append(productLink, textNode('p', strings.error));
      }
      const remove = textNode('button', strings.remove, 'sk-wishlist-remove'); remove.type = 'button'; remove.dataset.skWishlistRemove = handle;
      detail.append(remove); row.append(detail); list.append(row);
    });
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-sk-wishlist-toggle]');
    if (toggle) {
      event.preventDefault(); event.stopPropagation();
      const handle = toggle.dataset.productHandle;
      if (!validHandle(handle)) return;
      const removing = saved.includes(handle);
      saved = removing ? saved.filter(value => value !== handle) : [...saved, handle];
      persist(); status.textContent = removing ? strings.removed : strings.added;
      return;
    }
    const open = event.target.closest('[data-sk-wishlist-open]');
    if (open) { event.preventDefault(); if (!drawer.open) drawer.showModal(); render(); return; }
    const remove = event.target.closest('[data-sk-wishlist-remove]');
    if (remove) { saved = saved.filter(handle => handle !== remove.dataset.skWishlistRemove); persist(); render(); return; }
    if (event.target.closest('[data-sk-close]')) drawer.close();
  }, true);
  drawer.addEventListener('click', event => { if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) drawer.close(); } });
  window.addEventListener('storage', event => { if (event.key !== storageKey) return; try { const values = JSON.parse(event.newValue || '[]'); if (Array.isArray(values)) saved = [...new Set(values.filter(validHandle))].slice(0,100); } catch (_) {} update(); if (drawer.open) render(); });
  document.addEventListener('shopify:section:load', update);
  const observer = new MutationObserver(records => { if (records.some(record => Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches('[data-sk-wishlist-toggle]') || node.querySelector('[data-sk-wishlist-toggle]'))))) update(); });
  observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  update();
  const welcome = document.getElementById('sk-welcome-dialog');
  if (!welcome) return;
  const welcomeKey = `shakuntala-welcome-${welcome.dataset.offerCode}`;
  const dismiss = () => { try { sessionStorage.setItem(welcomeKey, 'seen'); } catch (_) {} };
  welcome.addEventListener('close', dismiss);
  welcome.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-sk-welcome-close]')) { dismiss(); welcome.close(); }
    if (event.target.closest('[data-sk-welcome-dismiss]')) dismiss();
    const copy = event.target.closest('[data-sk-copy-code]');
    if (copy) { try { await navigator.clipboard.writeText(welcome.dataset.offerCode); copy.textContent = copy.dataset.copied; } catch (_) { const range = document.createRange(); range.selectNodeContents(welcome.querySelector('.sk-welcome-code strong')); const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); } }
  });
  let show = true;
  try { show = !sessionStorage.getItem(welcomeKey); } catch (_) {}
  if (show) setTimeout(() => { if (!document.querySelector('dialog[open]') && !document.hidden) { welcome.showModal(); dismiss(); } }, Number(welcome.dataset.delay) || 2000);
})();

